import api from "../../client";

export type LearnerTagsResponseData = string[];

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export const getLearnerTagsRequest =
  async (): Promise<LearnerTagsResponseData> => {
    const { data } = await api.get<ApiResponse<LearnerTagsResponseData>>(
      "/profile/enums/learner-tags",
    );
    return data.data;
  };
